import React, {useRef} from 'react';
import {
    Button,
    Drawer,
    useDisclosure,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Box,
    DrawerBody,
    DrawerFooter,
    Flex, Text, Center
} from "@chakra-ui/react";
import SvgMenuLogo from "../../../../assets/svg/SvgMenuLogo";
import SvgLocation from "../../../../assets/svg/SvgLocation"
import {links} from "../../navDatat";
import {Link} from "react-scroll";
import { ADDRESS, PHONE_NUMBER_LINK } from '../../../../helpers/adminData';
import { NavLink } from 'react-router-dom';

const MobileNavbar = () => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const btnRef = useRef()
    return (
        <Box display={{base:"block",md:"none"}}>
            <Button ref={btnRef} variant="none" bg="none" onClick={onOpen}>
                <SvgMenuLogo/>
            </Button>
            <Drawer
                isOpen={isOpen}
                placement='top'
                onClose={onClose}
                finalFocusRef={btnRef}
            >
                <DrawerOverlay/>
                <DrawerContent  borderRadius="0px 0px 26px 26px;">
                    <DrawerCloseButton mt="15.71px" />
                    <DrawerBody pt="47px">
                        <Box p="47px 62px">
                            <Flex justifyContent="space-between" pb="11px">
                                <Flex flexDir="column">
                                    {links.slice(0, 2).map(({id, link, item}) => (
                                        <Box pb="37px" key={id} cursor="pointer">
                                            <Link onClick={onClose} to={link} smooth duration={500}>
                                                <Text fontFamily='Raleway' fontSize="14px" fontWeight="600"
                                                      color="#1B1918">{item}</Text>
                                            </Link>
                                        </Box>
                                    ))}
                                </Flex>
                                <Flex flexDir="column">
                                    {links.slice(3, 5).map(({id, link, item}) => (
                                        <Box pb="37px" key={id}>
                                            <Link onClick={onClose} to={link} smooth duration={500}>
                                                <Text cursor="pointer" fontFamily='Raleway' fontSize="14px"
                                                      fontWeight="600" color="#1B1918">{item}</Text>
                                            </Link>
                                        </Box>
                                    ))}
                                </Flex>
                            </Flex>
                            <Center mx="auto" w="174px" borderTop="1px solid #EBEBEB;" borderBottom="1px solid #EBEBEB;">
                                {links.slice(2, 3).map(({id, link, item}) => (
                                    <Box pt="19px" pb="14.61px" key={id}>
                                        <Link onClick={onClose} to={link} smooth duration={500}>
                                            <Text cursor="pointer" fontSize="14px" fontWeight="600"
                                                  color="#1B1918">{item}</Text>
                                        </Link>
                                    </Box>
                                ))}
                            </Center>
                        </Box>
                        <Flex justifyContent={'center'}>
                            <NavLink to={PHONE_NUMBER_LINK}   fontFamily="Raleway" fontWeight="400">
                                +996 555-86-60-70
                            </NavLink>
                        </Flex>
                    </DrawerBody>
                    <DrawerFooter>
                        <Box mx="auto">
                            <Flex alignItems="center" justifyContent="center">
                                <SvgLocation/>
                                <a target={`_blank`} href={`${ADDRESS}`}><Text pl="13.13px" fontFamily="Raleway" fontWeight="400" fontSize="14px" color="#000000">Адрес</Text></a>
                            </Flex>

                            <a target={`_blank`} href={`${ADDRESS}`}><Text fontFamily='Raleway' fontWeight="400" fontSize="12px" color="#202020" opacity="0.5"
                                  pt="4px" pb="33px">г. К-Балта, Ул. Кожомбердиева-3</Text></a>
                            <Box onClick={onClose} mx="auto" w="91px" h="6px" bg="#D9D9D9" borderRadius="22px"/>
                        </Box>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </Box>
    )
};

export default MobileNavbar;
